export default "__VITE_ASSET__CmiKkeqp__"